var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 17",
  preserveAspectRatio: "xMidYMid meet"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.6 0H1.196C.536 0 0 .544 0 1.211V15.59c0 .667.536 1.211 1.196 1.211H15.6c.66 0 1.2-.544 1.2-1.211V1.21C16.8.544 16.26 0 15.6 0M5.078 14.4h-2.49V6.383H5.08V14.4zm-1.246-12c.8 0 1.444.645 1.444 1.444s-.645 1.443-1.443 1.443a1.44 1.44 0 0 1-1.444-1.443c0-.799.645-1.444 1.444-1.444m10.58 12h-2.49v-3.9c0-.93-.02-2.126-1.295-2.126-1.297 0-1.496 1.012-1.496 2.058V14.4h-2.49V6.383H9.03v1.095h.034c.334-.63 1.147-1.294 2.358-1.294 2.52 0 2.99 1.661 2.99 3.821z"
})));
export default SvgLinkedin;